// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__RzjRa","neutral":"Badge_neutral__MFRHu","success":"Badge_success__uzGXI","warning":"Badge_warning__kNOi3","danger":"Badge_danger__IcTns"};